import { Location } from '@app/shared/routes';

const LegalLocation = new Location({
  path: '/legal'
});

export { LegalLocation };
